import React from 'react';
import "./tabsNav.scss"
const ListNav = ({items,selectedItem,textProperty,itemValue,onItemSelect, classes}) => {
    return (
        <ul className={classes}>
            {items.map((item) => (
                item.hide === true ?
                    <></>
                    :
                    <li
                        className={selectedItem === item[itemValue] ? 'active' : ''}
                        key={item[itemValue]}
                        onClick={() => onItemSelect(item[itemValue])}
                    >
                        {item[textProperty]}
                    </li>
            ))}
        </ul>
    );
};

export default ListNav;
